module.exports = __webpack_public_path__ + "img/holi.18635d23.jpg";